
















































import { Vue, Component } from 'vue-property-decorator'
import { RepairsItemsGetResponse } from '@/dtos/repairs/items/get'
import { buildingsModule } from '@/stores/buildings-store'
import { Column, Row, Cell } from '@/components/molecules/SmTableRepairPlanDetail.vue'
import { repairsModule } from '@/stores/repairs-store'
import { staticRoutes } from '@/routes'

/**
 * periodごとの列のid（period1 , period2・・・）。ヘッダ行とデータ行とで各カラムのidを一致させる。
 */
function getPeriodId(period: number): string {
  return 'period' + period
}

@Component({
  components: {
    SmBadgeInline: () => import('@/components/atoms/SmBadgeInline.vue'),
    SmText: () => import('@/components/atoms/SmText.vue'),

    SmTableRepairPlanDetail: () => import('@/components/molecules/SmTableRepairPlanDetail.vue'),

    SmOwBtnText: () => import('@/components/owner-apps/SmOwBtnText.vue'),
  }
})
export default class RepairPlanConstructionSubPage extends Vue {
  private get repairsItems(): RepairsItemsGetResponse { return repairsModule.repairsItemsGet }

  outputPDF(): void {
    this.$router.push({ name: staticRoutes.repairPlanDetailConstructionPrint.name })
  }

  // ヘッダ行
  private get columns(): Column[] {
    // ラベル列 -> 期の一覧 -> 総計列 という構造の表を作る。
    const periods = this.repairsItems?.totalRows?.periodTotals.map(total => {
      return {
        id: getPeriodId(total.period),
        period: total.period,
        yearMonth: buildingsModule.periodToYearMonth(total.period)
      }
    }) ?? []
    return [{ id: 'rowLabel', isCategoryColumn: true }, ...periods, { id: 'itemTotal', isTotalColumn: true }]
  }

  // データ行（全体）
  private get rows(): Row[] {
    return [...this.detailRows, ...this.totalRows]
  }

  // データ行（明細）
  private get detailRows(): Row[] {
    // カテゴリの配列がそれぞれ修繕項目の配列を持っているものを、フラットな1つの配列に変換
    return this.repairsItems?.detailRows?.categories.flatMap(category => {
      const periods = category.items.map(item => {
        const cells = item.periods.reduce((acc: Record<string, Cell>, current) => {
          acc[getPeriodId(current.period)] = { prospect: current.prospect ?? undefined, performance: current.performance ?? undefined }
          return acc
        }, {})

        return { rowLabel: item.itemLabel, cells: cells, itemTotal: { total: item.total } }
      })

      return [
        { rowLabel: category.categoryLabel, isCategoryRow: true },
        ...periods,
      ]
    }) ?? []
  }

  // データ行（合計値）
  private get totalRows(): Row[] {
    if (!this.repairsItems) return []
    const taxExcludedCells : Record<string, Cell> = {}
    const taxCells : Record<string, Cell> = {}
    const taxIncludedCells : Record<string, Cell> = {}
    const cumulativeCells : Record<string, Cell> = {}

    if (this.repairsItems?.totalRows?.periodTotals) {
      for (const periodTotal of this.repairsItems.totalRows.periodTotals) {
        const periodId = getPeriodId(periodTotal.period)

        taxExcludedCells[periodId] = { total: periodTotal.taxExcluded }
        taxCells[periodId] = { total: periodTotal.tax }
        taxIncludedCells[periodId] = { total: periodTotal.taxIncluded }
        cumulativeCells[periodId] = { total: periodTotal.cumulative }
      }
    }

    const rowTotal = this.repairsItems?.totalRows?.rowTotal
    return [
      { rowLabel: '単年度修繕費', cells: taxExcludedCells, itemTotal: { total: rowTotal?.taxExcluded }, isBlueTotalRow: true },
      { rowLabel: '単年度消費税', cells: taxCells, itemTotal: { total: rowTotal?.tax }, isBlueTotalRow: true },
      { rowLabel: '単年度合計', cells: taxIncludedCells, itemTotal: { total: rowTotal?.taxIncluded }, isGrayTotalRow: true },
      { rowLabel: '修繕費累計', cells: cumulativeCells, itemTotal: { total: rowTotal?.cumulative }, isGrayTotalRow: true },
    ]
  }
}
